import * as React from 'react';
import {messageBoxError, messageBoxSuccess} from '@deviceinsight/ng-ui-components';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';

const createErrorMessageContent = (error: any): React.ReactElement<any> => {
	const {
		response: {
			data: {message}
		}
	} = error;
	return (
		<div>
			{!message && (
				<div>
					<Trans i18nKey="api.error.title">An error has occurred</Trans>
				</div>
			)}
			<div>{message}</div>
		</div>
	);
};

const displayErrorMessage = (e: any, moduleName: string): void => {
	messageBoxError(createErrorMessageContent(e), undefined, moduleName);
};

const displayConfirmMessage = (content: React.ReactElement<any>): void => {
	messageBoxSuccess(content, {
		autoClose: 4000
	});
};

export {displayErrorMessage, displayConfirmMessage};
